import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The shadcn class-name combiner. Re-exported here (rather than only in
 * `@/lib/states`) so the vendored shadcn/base components can keep their
 * canonical `@/lib/utils` import path unchanged.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
